module.exports = __webpack_public_path__ + "static/media/izlozba (18).52bc1acc.JPG";